export const removeUndefinedValues = (o) => JSON.parse(JSON.stringify(o));
